export default "__VITE_ASSET__ChBb_3Ae__"